import styled from 'styled-components';

// @ts-nocheck
var Tags = styled.ul.withConfig({
  displayName: "Tagsstyle__Tags",
  componentId: "sc-2cji58-0"
})(["display:flex;flex-wrap:wrap;gap:var(--space-300);"]);

export { Tags };
//# sourceMappingURL=Tags.style.js.map
